<div class="container-platform-core" [class.close]="!menuLeftService.menuLeftOpen()">
    
    <!-- Menu top -->
    <menu-top />
    
    <!-- Menu left -->
    <menu-left />
    
    <!-- Pages -->
    <router-outlet></router-outlet>
</div>
